const siqa = {
  C003TiposDeSentidoDeSentencia: 'SIQA/Catalogos/GetTiposDeSentidosDeSentencia'
};

export default siqa;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/SIQA/catalogos/siqa.js
// module id = null
// module chunks = 